import http from 'common-module/src/util/http';

/**
 *  获取项目视图列表
 * @param {*} data
 * @returns
 */
export async function getRoadmapProjectList(data) {
  return http.post(
    '/road-map/query-project-by-project-view-mode',
    data
  );
}

/**
 *  获取筛选条件
 * @param {*} data
 * @returns
 */
export async function getRoadmapFilters(data) {
  return http.post('/road-map/query-condition-data', data);
}

/**
 * 记录用户行为习惯
 * @param {*} data
 * @returns
 */
export async function habitRecord(data) {
  return http.post('/account/habit-record', data);
}

//用户习惯查询
export async function habitQuery(data) {
  return http.post('/account/habit-query', data);
}

/**
 *  获取项目视图列表
 * @param {*} data
 * @returns
 */
export async function getRoadmapProjectEpicList(data) {
  return http.post('road-map/query-epic-by-project-view-mode', data);
}

/**
 *  获取史诗下的工作列表层级数据(项目视图)
 * @param {*} data
 * @returns
 */
export async function getEpicIssueByProjectViewMode(data) {
  return http.post(
    'road-map/query-epic-issue-by-project-view-mode',
    data
  );
}

/**
 *  获取迭代列表层级数据(项目视图)
 * @param {*} data
 * @returns
 */
export async function getSprintByProjectViewMode(data) {
  return http.post(
    '/road-map/query-sprint-by-project-view-mode',
    data
  );
}

/**
 *  获取迭代下的工作列表层级数据(项目视图)
 * @param {*} data
 * @returns
 */
export async function getSprintIssueByProjectViewMode(data) {
  return http.post(
    '/road-map/query-sprint-issue-by-project-view-mode',
    data
  );
}

/**
 *  获取版本列表层级数据(版本视图)
 * @param {*} data
 * @returns
 */
export async function getVersionListByVersionViewMode(data) {
  return http.post(
    '/road-map/query-version-by-version-view-mode',
    data
  );
}

/**
 * 获取迭代列表层级数据(版本视图)
 * @param {*} data
 * @returns
 */
export async function getSprintListByVersionViewMode(data) {
  return http.post(
    '/road-map/query-sprint-by-version-view-mode',
    data
  );
}

/**
 * 获取史诗列表层级数据(版本视图)
 * @param {*} data
 * @returns
 */
export async function getEpicListByVersionViewMode(data) {
  return http.post(
    '/road-map/query-epic-by-version-view-mode',
    data
  );
}

/**
 * 获取史诗下的工作列表层级数据(版本视图)
 * @param {*} data
 * @returns
 */
export async function getEpicIssueListByVersionViewMode(data) {
  return http.post(
    '/road-map/query-epic-issue-by-version-view-mode',
    data
  );
}

/**
 * 获取迭代下的工作列表层级数据(版本视图)
 * @param {*} data
 * @returns
 */
export async function getSprintIssueListByVersionViewMode(data) {
  return http.post(
    '/road-map/query-sprint-issue-by-version-view-mode',
    data
  );
}

/**
 * 发布时间范围更新
 * @param {*} data
 * @returns
 */
export async function updateReleaseDateRange(data) {
  return http.post('/release/update/time-range', data);
}

/**
 * 修改迭代开始结束时间
 * @param {*} data
 * @returns
 */
export async function updateSprintDateRange(data) {
  return http.post('/sprint/edit/time-range', data);
}

/**
 * 更新issue
 * @param {*} data
 * @returns
 */
export async function updateIssue(data) {
  return http.post('/issue/update', data);
}

/**
 * 更新Project
 * @param {*} data
 * @returns
 */
export async function updateProjectTime(data) {
  return http.post('/project/update/time-range', data);
}

/**
 * 获取有史诗字段的事项类型
 * @param {*} projectId
 * @returns
 */
export async function getEpicIssueTypeList(projectId) {
  const result = await http.post('/epic/issue-type-options', { pageSize: 50, projectId });
  return result.map(t => ({
    key: t.id,
    icon: t.iconUrl,
    ...t
  }));
}

/**
 * 通过项目获取事项类型
 * @param {*} projectId
 * @returns
 */
export async function getIssueTypeList(projectId) {
  const result = await http.post('/issue-type/list-selector/project-id', { pageSize: 50, projectId });
  return result.map(t => ({
    key: t.id,
    icon: t.iconUrl,
    ...t
  }));
}

/**
 * 快速创建事项
 * @param {*} data
 * @returns
 */
export async function addQuickIssue(data) {
  return http.post('/issue/add-v3', data);
}


/**
 * 快速创建史诗
 * @param {*} data
 * @returns
 */
export async function addQuickEpic(data) {
  return http.post('/issue/add-epic-v2', data);
}

/**
 * 快速创建迭代
 * @param {*} data
 * @returns
 */
export async function addQuickSprint(data) {
  return http.post('sprint/add', data);
}

/**
 * 获取史诗详情
 * @param {*} data
 * @returns
 */
export async function loadEpic(data) {
  return http.post('/epic/load', data);
}


/**
 * 获取迭代详情
 * @param {*} data
 * @returns
 */
export async function loadSprint(data) {
  return http.post('/sprint/get', data);
}

/**
 * 创建里程碑
 * @param {*} data
 * @returns
 */
export async function createMilestone(data) {
  return http.post('/milestone/create', data);
}
/**
 * 删除里程碑
 * @param {*} data
 * @returns
 */
export async function deleteMilestone(data) {
  return http.post('/milestone/delete', data);
}

/**
 * 编辑里程碑
 * @param {*} data
 * @returns
 */
export async function updateMilestone(data) {
  return http.post('/milestone/edit', data);
}

/**
 * 获取里程碑列表
 * @param {*} data
 * @returns
 */
export async function getMilestoneList(data) {
  return http.post('/milestone/query-list', data);
}

/**
 * 获取非工作日列表
 * @param {*} data
 * @returns
 */
export async function getHolidayList(data) {
  return http.post('/org-holiday/query-range-non-work-day', data);
}

/**
 * 添加关联关系
 * @param {*} data
 * @returns
 */
export async function addIssueRelationship(data) {
  return http.post('/issue/add-issue-relationship', data);
}

/**
 * 解除关联关系
 * @param {*} data
 * @returns
 */
export async function removeIssueRelationship(data) {
  return http.post('/issue/remove-issue-relationship', data);
}

/**
 * 获取关联关系接口（20221110迭代独立）
 * @param {*} data
 * @returns
 */
export async function getRoadmapRelationship(data) {
  return http.post('/road-map/query-block-relation', data);
}

/**
 * 批量获取项目史诗接口
 * @param {*} data
 * @returns
 */
export async function getBatchProjectEpics(data) {
  return http.post('/road-map/query-batch-by-project-epic', data);
}

/**
 * 批量获取项目迭代接口
 * @param {*} data
 * @returns
 */
export async function getBatchProjectSprints(data) {
  return http.post('/road-map/query-batch-by-project-sprint', data);
}

/**
 * 批量获取版本史诗接口
 * @param {*} data
 * @returns
 */
export async function getBatchVersionEpics(data) {
  return http.post('/road-map/query-batch-by-version-epic', data);
}

/**
 * 批量获取版本迭代接口
 * @param {*} data
 * @returns
 */
export async function getBatchVersionSprints(data) {
  return http.post('/road-map/query-batch-by-version-sprint', data);
}


/**
 * 获取Issue的子任务列表
 * @param {*} data
 * @returns
 */
export async function getSubtaskListByIssueId(data) {
  return http.post('/issue/subtask-list/issue-id', data);
}
